module.exports = __webpack_public_path__ + "static/media/shower_cap.be8766f4.svg";